export { default } from "./ModuleDetail";

